<template>
    <div class="cs-defaultServiceFeatures">
        <div class="cs-defaultServiceFeatures__header" v-on:click="toggleAreFeaturesShown()">
            <div class="cs-defaultServiceFeatures__headerTitle">{{dictionary.serviceFeatures}}</div>
            <div  class="cs-defaultServiceFeatures__arrowWrapper" >
                <div class="cs-defaultServiceFeatures__arrow" :class="{'cs-defaultServiceFeatures__arrow--down': areFeaturesShown}"></div>
            </div>
        </div>
        <div class="cs-defaultServiceFeatures__items" :class="{'cs-defaultServiceFeatures__items--shown': areFeaturesShown}">
            <div class="cs-defaultServiceFeatures__item" v-for="feature of getOfferFeatures()" v-bind:key="feature">
                <div class="cs-defaultServiceFeatures__itemIconWrapper">
                    <div class="cs-defaultServiceFeatures__itemIcon"></div>
                </div>
                <div class="cs-defaultServiceFeatures__itemText">{{feature}}</div>
            </div>
        </div>
        
    </div>
</template>

<script>
    export default {
        name: 'DefaultServiceFeatures',
        props: [
            "offer", "dictionary"
        ],
        data: function(){
            return {
                areFeaturesShown: false
            }
        },
        methods:{
            getOfferFeatures(){
                return this.offer.serviceFeatures.serviceFeaturesList.split(',');
            },
            toggleAreFeaturesShown(){
                this.areFeaturesShown = !this.areFeaturesShown;
            }
        },
    }
</script>

<style lang="scss" scoped>
    .cs-defaultServiceFeatures {
        overflow: hidden;
        &__header {
            display: grid;
            grid-template-columns: 1fr 50px ;
            height: 50px;
            cursor: pointer;
            border-top: 1px solid #D9D9D9;

            &Title{
                grid-column: 1 / span 2;
                grid-row: 1;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #7762EF;
                font-size: 16px;
                font-weight: 400;
            }
        }

        &__arrow {
            width:6px;
            height:6px;
            border-width: 0 3px 3px 0;
            border-style: solid;
            border-color: #7762EF;
            transform: rotate(-45deg);
            transition: transform 1s;

            &--down{
                transform: rotate(45deg);
                transition: transform 1s;
            }

            &Wrapper {    
                display: flex;
                align-items: center;
                justify-items: center;
                grid-column: 2;
                grid-row: 1;
            }
        }

        &__item{
            display: flex;

            &s{
                max-height: 0px;
                padding: 0px 20px;
                transition: max-height 1s, padding 1s;
                &--shown{
                    max-height: 400px;
                    height: fit-content;
                    padding: 0px 20px 20px;
                    transition: max-height 1s, padding 1s;
                }
                
            }

            &Icon{
                width: 5px;
                height: 5px;
                background-color: #7762EF;
                border-radius: 100%;
                margin-right: 10px;

                &Wrapper {
                    display: flex;
                    align-items: center;
                }
            }

            &Text{
                color: #7A7A7A;
                font-size: 14px;
                text-align: left;
            }
        }

    }
</style>